import type { ReactNode } from "react";
import "./DailyTagsSelector.scss";
import useDailyTagsSelectorController from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/daily-tags-selector/useDailyTagsSelectorController.ts";
import FlatSelectMulti from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select-multi/FlatSelectMulti.tsx";

export default function DailyTagsSelector(): ReactNode {
  const controller = useDailyTagsSelectorController();

  return (
    <div className="daily-tags-selector">
      <FlatSelectMulti
        title={controller.title}
        items={controller.items}
        isSelectedItem={controller.isSelectedItem}
        onSelectItem={controller.toggleItem}
        showSelectAll={true}
        onSelectAll={controller.selectAll}
        onSelectNone={controller.selectNone}
        folded={controller.folded}
        onFoldedChanged={controller.setFolded}
      />
    </div>
  );
}
